if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
  });

  $(".logos-slides").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true
        },
      },
    ],
  });

  $(".images-slides").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    accessibility: false,
  });

  $(".images-slides figure").attr("aria-hidden", false);

  $(".slider-info").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 700,
    fade: true,
    accessibility: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".slider-bg-info").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 700,
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".reviews-slides").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    accessibility: false,
    adaptiveHeight: true,
  });

  $(".slider-gallery").slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          fade: false,
          variableWidth: true,
        },
      },
    ],
  });

  $(".slider-images").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slides-gift").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          arrows: true,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });


  let ScrollDown = document.getElementsByClassName("js-scrolldown");
  if (ScrollDown.length > 0) {
    ScrollDown[0].addEventListener("click", function () {
      animateto("intro");
    });
  }

  //FAQ
  setTimeout(function () {
    $(".tab-label").each(function () {
      let thisHeightTap = $(this).height() + 44;
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeightTap + "px" }, 400);
      if ($(this).hasClass("open")) {
        $(this)
          .parent()
          .animate({ height: thisHeight + "px" }, 400);
      }
    });
    $(".learn-more-btn").append('<div class="arrow"></div>');
  }, 400);

  $(".tab-label").click(function () {
    let currentclick = $(this);
    let thisHeightTap = $(this).height() + 44;

    let slideIndex = $(this).data("artwork");
    $(".accordion-slide").slick("slickGoTo", parseInt(slideIndex));

    if (!currentclick.hasClass("open")) {
      $(".tab-label").each(function () {
        if ($(this) !== currentclick) {
          if ($(this).hasClass("open")) {
            let thisHeight = $(this).height() + 44;
            $(this).removeClass("open");
            $(this)
              .parent()
              .animate({ height: thisHeight + "px" }, 400);
          }
        }
      });
      currentclick.addClass("open");
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeight + "px" }, 400);
    } else {
      currentclick.removeClass("open");
      currentclick.parent().animate({ height: thisHeightTap + "px" }, 400);
    }
  });

  $("[data-fancybox]").fancybox({
    loop: true,
    backFocus: false,
    autoFocus: false,
  });

  $(
    "a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a.btn-book, a.close))"
  ).click(function (e) {
    e.preventDefault();
    let strAncla = $(this).prop("hash").substr(1);
    animateto(strAncla);
  });

  let screenHeight = $(window).height();
  $("#home .top-img figure, #home .top-img video").css("height", screenHeight);

  $(window).resize(function () {
    screenHeight = $(window).height();
    $("#home .top-img figure, #home .top-img video").css(
      "height",
      screenHeight
    );
  });

  //Accordion Function ***************************************

  const acc_btns = document.querySelectorAll(".accordion__button");
  const acc_items = document.querySelectorAll(".accordion__item");
  if (acc_btns) {
    for (let i = 0; i < acc_btns.length; i++) {
      acc_btns[i].addEventListener("click", function () {
        if (this.closest(".accordion__item").classList.contains("active")) {
          this.closest(".accordion__item").classList.remove("active");
        } else {
          for (let a = 0; a < acc_items.length; a++) {
            acc_items[a].classList.remove("active");
          }
          this.closest(".accordion__item").classList.add("active");
        }
      });
    }
  }

  if ($(".accordion__filter").length > 0) {
    $(".accordion__filter ul li").click(function () {
      const thisTag = $(this).attr("data-tag");
      if (thisTag != "all") {
        $(".accordion__container .accordion__item").hide();
        $(".accordion__container ." + thisTag).fadeIn();
        $(".accordion__filter ul li").removeClass("active");
        $(this).addClass("active");
      } else {
        $(".accordion__container .accordion__item").fadeIn();
        $(".accordion__filter ul li").removeClass("active");
        $(this).addClass("active");
      }
    });
  }

  if (document.querySelector(".accordion__filter")) {
    const filter_tab = document.querySelectorAll(".accordion__filter ul li");
    filter_tab[filter_tab.length - 2].click();
  }

  $(".text-modules").addClass("animate-fade top");

  $(".form-module").addClass("animate-fade top");

  if ($("#filter-tabs-accordion").length > 0) {
    $("#filter-tabs-accordion").val("all").trigger("change");
  }
})();

function animateto(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 130;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var y = easeInOutQuart(time, from, to - from, duration);
    } else {
      var y = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, y);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
